import type { OrganizationHivesResponse } from '@/generated/http-clients/v2ApiSchemas'
import type { UseQueryResult } from '@tanstack/react-query'

export function isOrgNotFound(
  hives: Pick<
    UseQueryResult<OrganizationHivesResponse, unknown>,
    'isSuccess' | 'data'
  >,
) {
  if (!hives.isSuccess) {
    return false
  }
  const hasUsers = (hives.data?.users_info?.length ?? 0) > 0
  const hasName = Boolean(hives.data?.company_name?.trim())
  const hasHives = (hives.data?.hives_info?.length ?? 0) > 0
  return !hasUsers && !hasName && !hasHives
}
